import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3727e143"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table table-hover table-v2" }
const _hoisted_2 = { class: "border-dark border-bottom" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, " ", -1))
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, " ", -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  colspan: "6",
  class: "fw-bold small text-uppercase text-muted"
}
const _hoisted_11 = { class: "status" }
const _hoisted_12 = {
  class: "d-flex justify-content-center align-items-center",
  style: {"cursor":"pointer"}
}
const _hoisted_13 = ["onClick", "data-dp-tooltip"]
const _hoisted_14 = { class: "simulate" }
const _hoisted_15 = { class: "btn btn-icon btn-warning ms-2" }
const _hoisted_16 = ["onClick", "data-dp-tooltip"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "mb-4" }
const _hoisted_19 = {
  key: 2,
  class: "simulation-output mt-4"
}
const _hoisted_20 = { class: "mb-2" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "list-unstyled ms-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas mas-check-circle text-success me-2" }, "check", -1))
const _hoisted_24 = {
  key: 1,
  class: "text-muted ms-2"
}
const _hoisted_25 = { class: "buttons d-flex justify-content-end align-items-center mt-3" }
const _hoisted_26 = {
  type: "submit",
  class: "btn btn-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_placeholder_table = _resolveComponent("base-placeholder-table")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_Subtitle = _resolveComponent("Subtitle")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTitle, {
          title: _ctx.$t('userRegistrationRules'),
          "help-text": _ctx.$t('descriptionUserRegistrationRuleOverview'),
          "show-refresh-button": "",
          onRefresh: _ctx.reloadContent
        }, null, 8, ["title", "help-text", "onRefresh"]),
        _createVNode(_component_AlertError2, {
          error: _ctx.pageUI.getError()
        }, null, 8, ["error"]),
        _createElementVNode("table", _hoisted_1, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('name')), 1),
              _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('type')), 1),
              _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('conditionInfo')), 1),
              _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('resultInfo')), 1),
              _hoisted_8
            ])
          ]),
          _createElementVNode("tbody", null, [
            (!_ctx.pageUI.isReady())
              ? (_openBlock(), _createBlock(_component_base_placeholder_table, {
                  key: 0,
                  "n-cols": 5
                }))
              : (_ctx.overviewResult.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                    _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.$t('noResults')), 1)
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.overviewResult.results, (rule) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: "align-middle",
                      key: rule.rule_id
                    }, [
                      _createElementVNode("td", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("i", {
                            onClick: _withModifiers(($event: any) => (_ctx.updateStatus(rule.rule_id, rule.status.code === _ctx.StatusEnum.PUBLISHED ? _ctx.StatusEnum.NOT_PUBLISHED : _ctx.StatusEnum.PUBLISHED)), ["prevent"]),
                            class: _normalizeClass(["mas mas-fill-1", [rule.status.code === _ctx.StatusEnum.PUBLISHED ? 'text-success' : 'text-danger']]),
                            "data-dp-tooltip": rule.status.code === _ctx.StatusEnum.PUBLISHED ? _ctx.$t('published') : _ctx.$t('notPublished')
                          }, " circle ", 10, _hoisted_13)
                        ])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(rule.name), 1),
                      _createElementVNode("td", null, _toDisplayString(rule.type.description), 1),
                      _createElementVNode("td", null, _toDisplayString(rule.rule_condition_info), 1),
                      _createElementVNode("td", null, _toDisplayString(rule.rule_result_info), 1),
                      _createElementVNode("td", _hoisted_14, [
                        _createElementVNode("button", _hoisted_15, [
                          _createElementVNode("i", {
                            onClick: _withModifiers(($event: any) => (_ctx.openSimulationModal(rule)), ["prevent"]),
                            class: "mas mas-fill-1",
                            "data-dp-tooltip": _ctx.$t('simulate')
                          }, " sound_sampler ", 8, _hoisted_16)
                        ])
                      ])
                    ]))
                  }), 128))
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_base_modal, {
      "modal-id": _ctx.simulateModalId,
      title: _ctx.$t('simulate'),
      "no-footer": ""
    }, {
      default: _withCtx(() => [
        (_ctx.simulationRule !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(_component_dp_form, {
                as: "form",
                onSubmit: _ctx.simulate,
                novalidate: ""
              }, {
                default: _withCtx(({ errors }) => [
                  _createVNode(_component_AlertError2, {
                    error: _ctx.pageUI.getError()
                  }, null, 8, ["error"]),
                  _createVNode(_component_Subtitle, {
                    title: _ctx.$t('urrSimulationRule')
                  }, null, 8, ["title"]),
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.simulationRule?.name), 1),
                  ('CG_ID_REG_CODE' !== _ctx.simulationRule?.type.code)
                    ? (_openBlock(), _createBlock(_component_InputText, {
                        key: 0,
                        modelValue: _ctx.simulateInput.email,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.simulateInput.email) = $event)),
                        modelModifiers: { trim: true },
                        name: "email",
                        label: _ctx.$t('email'),
                        errors: errors
                      }, null, 8, ["modelValue", "label", "errors"]))
                    : _createCommentVNode("", true),
                  ('CG_ID_REG_CODE' === _ctx.simulationRule?.type.code)
                    ? (_openBlock(), _createBlock(_component_InputText, {
                        key: 1,
                        modelValue: _ctx.simulateInput.registration_code,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.simulateInput.registration_code) = $event)),
                        modelModifiers: { trim: true },
                        name: "registration_code",
                        label: _ctx.$t('registrationCode'),
                        errors: errors
                      }, null, 8, ["modelValue", "label", "errors"]))
                    : _createCommentVNode("", true),
                  (_ctx.simulationOutput !== null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createVNode(_component_Subtitle, {
                          title: _ctx.$t('simulationResult'),
                          mb: "3"
                        }, null, 8, ["title"]),
                        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('urrSimulationResultCgs')), 1),
                        (_ctx.simulationOutput.client_groups?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createElementVNode("ul", _hoisted_22, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.simulationOutput.client_groups, (group) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: group,
                                    class: "py-1"
                                  }, [
                                    _hoisted_23,
                                    _createTextVNode(" " + _toDisplayString(group), 1)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.$t('none')), 1))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_base_modal_button, {
                      mode: "close",
                      class: "btn btn-outline-primary me-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("button", _hoisted_26, _toDisplayString(_ctx.$t('simulationResult')), 1)
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modal-id", "title"])
  ], 64))
}